import ReactDOM from 'react-dom';


class Hotspot {
    constructor({ content, hint = null, onClick = (e) => { }, className, position, cameraStart = null }) {
        this.content = content;
        this.onClick = onClick;
        this.className = `hotspot hotspot-${className}`;
        this.position = { ...position };
        this.hint = hint;

        this.hotspot = this.createHotspot();

    }
    createHotspot() {
        var hotspotElement = document.createElement('div');
        hotspotElement.className = this.className;
        hotspotElement.innerHTML = `<div class="hotspot-container">${this.content}</div>`;

        hotspotElement.onclick = this.onClick;
        hotspotElement.onmouseover =
            () => {
                this.openPopup(hotspotElement);
            };

        if (this.hint !== null) {
            this.createHint(hotspotElement);
        }
        return hotspotElement;
    }

    getHotspot() {
        return this.hotspot;
    }

    openPopup(parent) {


    }

    createHint(parent) {
        if (this.hint !== null) {
            var text = document.createElement('div');
            text.className = "hint-hotspot"
            text.innerHTML = `<div>${this.hint}</div>`
            parent.querySelector(".hotspot-container").appendChild(text);
        }
    }

    setPosition(pos)
    {
        this.position = {...this.position,...pos}; 
    }

}

export default Hotspot